module.exports = {"330211001":"招宝山街道","330211002":"蛟川街道","330211003":"骆驼街道","330211004":"庄市街道","330211005":"贵驷街道","330211100":"澥浦镇","330211101":"九龙湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330211.json
// module id = 959
// module chunks = 0